import { globalReducer } from '@dealstack/frontend/shared/mechanism/redux/reducers/global/global';
import { userReducer } from '@dealstack/frontend/shared/mechanism/redux/reducers/user/user';
import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { MipManage as mipManage } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/MipManage.slice';
import { Deal as deal } from '@dealstack/frontend/app/pages/Project/DealDashboard/Deal.slice';
import { Organization as organization } from '@dealstack/frontend/app/pages/Organization/Organization.slice';

export const store = configureStore({
	reducer: {
		global: globalReducer,
		user: userReducer,
		mipManage,
		deal,
		organization,
	},
	enhancers: [Sentry.createReduxEnhancer({})],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
